module.exports = __webpack_public_path__ + "img/chr_ts_17.6ace15d0.png";